module.exports = __webpack_public_path__ + "static/assets/footer.04b55b61.png";